function getMonthName(months: string[], monthIndex: number) {
    return months[monthIndex > 11 ? monthIndex % 12 : monthIndex]
}

export default getMonthName;
